import { Component } from '@angular/core';
import { getCustomerToken } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { CartService } from 'src/app/services/cart.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-quick-cart',
  templateUrl: './quick-cart.component.html',
  styleUrls: ['./quick-cart.component.scss']
})
export class QuickCartComponent {
  baseUrl = environment.BASE_URL;
  cartItems: any;
  cartItemsError: Map<number, any> = new Map();
  cartMap: Map<number, any> = new Map();
  constructor(
    private router: Router,
    private route:ActivatedRoute,
    private commonService : CommonService,
    private cartService:CartService,
  ) {}

  ngOnInit(): void {
    this.quickCart();
  }
  quickCart() {
      let customerToken = getCustomerToken();
      if (customerToken) {
        let setCompanyId = sessionStorage.getItem('customercompanyId');
        let cartApi = `${this.baseUrl}rfq/cart/getCartItem?companyId=${setCompanyId}`;
        this.commonService.getData(cartApi).subscribe((data) => {
          this.cartItems = data?.response;
        });
      } else {
        let cartLocalData: any = sessionStorage.getItem('cartData');
        let dataItem = JSON.parse(cartLocalData);
        this.cartItems = dataItem != null ? Object.values(dataItem) : [];
        // this.cartItems = Object.values(dataItem);
        this.setCartMap(this.cartItems)
      }
    }
    
  close = () => {};
  nevigateCheckout(){
    this.close();
    this.router.navigateByUrl('/prelogin')
  }
  setCartMap(cartData:any){
    cartData.forEach((product: any) => {
      if (this.cartMap.has(product.productId)) {
        let productItem = this.cartMap.get(product.productId);
        productItem.quantity = productItem.quantity + 1;
      } else {
        this.cartMap.set(product.productId, product);
      }
    });
  }
  removeProduct(id:number){
    this.cartMap.delete(id);
    this.updateQuantity();
    this.cartMap.clear();
    this.quickCart();
  }
  minusQuantity(productId: number) {
    let cartItem = this.cartMap.get(productId);
    cartItem.quantity = cartItem.quantity - 1;
    if(cartItem.quantity == 0){
      this.removeProduct(productId)
    }
    this.updateQuantity()
  }
  updateQuantity(): void {
    const obj = Object.fromEntries(this.cartMap.entries());
    sessionStorage.setItem('cartData', JSON.stringify(obj));
    let responseArray = Object.values(obj);
    let responseObject = {
      response: responseArray,
    };
    this.cartService.cartUpdates.next(responseObject);
  }
  addQuantity(productId: number,) {
    let cartItem = this.cartMap.get(productId);
    cartItem.quantity = cartItem.quantity + 1;
    this.updateQuantity()
  }
  inputQuantity(productId: number, event:any){
    let inputValue:number = event.target.valueAsNumber
    let cartItem = this.cartMap.get(productId);
    cartItem.quantity = inputValue;
    this.updateQuantity()
  }
}
